<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <!-- Page Header -->
    <div class="page-header">
      <button mat-icon-button routerLink="/user-profiles" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-content">
        <h2>Exibir Grupo de Usuário</h2>
        <p class="header-subtitle">Visualize os detalhes e permissões do grupo</p>
      </div>
    </div>

    @if (currentProfile !== null) {
      <app-user-profile-form [readonly]="true" [formData]="currentProfile" />
    }

    <!-- Actions -->
    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/user-profiles">
        <mat-icon>arrow_back</mat-icon>
        <span>Voltar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
